import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Bungen Lee - Fantasy & Science Fiction Author</title>
        <meta 
          name="description" 
          content="Discover the imaginative worlds of Bungen Lee. Fantasy and science fiction books available on Royal Road, Wattpad, Rakuten Kobo, and other platforms." 
        />
        <link rel="canonical" href="https://yourusername.github.io/bungen-lee-website/" />
        <meta property="og:title" content="Bungen Lee - Fantasy & Science Fiction Author" />
        <meta property="og:description" content="Discover the imaginative worlds of Bungen Lee. Available on Royal Road, Wattpad, Rakuten Kobo, and more." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://yourusername.github.io/bungen-lee-website/" />
      </Helmet>

      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content fade-in-up">
            <h1>Bungen Lee</h1>
            <p className="hero-subtitle">
              Raised in Calgary, Canada, Bungen Lee (pen name) has always had a passion for writing. As a child, he would spend countless hours scribbling stories in his notebook, often to the neglect of his schoolwork. However, it wasn't until later in life that Bungen realized that writing was his true calling.
            </p>
            <p className="hero-subtitle">
              Despite his love for writing, Bungen pursued a career in engineering, where he worked tirelessly as an engineer for many years. However, his desire to write never waned, and he spent every free moment honing his craft. He attended writing workshops, read every book on the craft of writing, and even took a course on creative writing online.
              </p>
            <p className="hero-subtitle">
                As an Asian Canadian writer, Bungen has always been interested in exploring the complexities of identity and culture in his writing. His stories often delve into the experiences of immigrants and their families, as well as the challenges of navigating life in a multicultural society.
            </p>
            <p className="hero-subtitle">
              Bungen is currently working on several of his writing projects in parallel, which he hopes to publish in the near future.
              </p>
            
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="features">
        <div className="container">
          <div className="section-header">
            <h2>Why Readers Love These Stories</h2>
            <p>Immersive worlds, compelling characters, and epic adventures await</p>
          </div>
          
          <div className="feature-grid">
            <div className="feature-card card">
              <div className="feature-icon">
                <i className="fas fa-dragon"></i>
              </div>
              <h3>Epic Fantasy</h3>
              <p>Journey through meticulously crafted worlds filled with magic, mystery, and unforgettable characters.</p>
            </div>
            
            <div className="feature-card card">
              <div className="feature-icon">
                <i className="fas fa-rocket"></i>
              </div>
              <h3>Historical Fiction</h3>
              <p>Explore historical landscapes and wonders that challenge the boundaries of imagination.</p>
            </div>
            
            <div className="feature-card card">
              <div className="feature-icon">
                <i className="fas fa-users"></i>
              </div>
              <h3>Rich Characters</h3>
              <p>Meet complex, relatable characters whose journeys will stay with you long after you finish reading.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content card">
            <h2>Ready to Begin Your Adventure?</h2>
            <p>Start reading today across multiple platforms</p>
            <Link to="https://www.smashwords.com/profile/view/BungenLee7295" className="btn btn-primary">
              <i className="fas fa-play"></i>
              Start Reading Now
            </Link>
          </div>
        </div>
      </section>

      <style jsx>{`
        .hero-buttons {
          display: flex;
          gap: 1rem;
          flex-wrap: wrap;
        }
        
        .section-header {
          text-align: center;
          margin-bottom: 4rem;
        }
        
        .section-header h2 {
          margin-bottom: 1rem;
        }
        
        .cta-section {
          padding: 5rem 0;
          background: var(--color-bg-secondary);
        }
        
        .cta-content {
          text-align: center;
          max-width: 600px;
          margin: 0 auto;
          padding: 4rem 2rem;
        }
        
        .cta-content h2 {
          margin-bottom: 1rem;
        }
        
        .cta-content p {
          margin-bottom: 2rem;
          font-size: 1.1rem;
        }
        
        @media (max-width: 768px) {
          .hero-buttons {
            justify-content: center;
          }
          
          .cta-content {
            padding: 3rem 1.5rem;
          }
        }
      `}</style>
    </>
  );
};

export default Home;